import { Instance } from 'mobx-state-tree';
import { ProjectRouteStopMovingDtoModelBase } from './ProjectRouteStopMovingDtoModel.base';

/* The TypeScript type of an instance of ProjectRouteStopMovingDtoModel */
export interface ProjectRouteStopMovingDtoModelType extends Instance<typeof ProjectRouteStopMovingDtoModel.Type> {}

/* A graphql query fragment builders for ProjectRouteStopMovingDtoModel */
export { selectFromProjectRouteStopMovingDto, projectRouteStopMovingDtoModelPrimitives, ProjectRouteStopMovingDtoModelSelector } from './ProjectRouteStopMovingDtoModel.base';

/**
 * ProjectRouteStopMovingDtoModel
 *
 * Stop unscheduling
 */
export const ProjectRouteStopMovingDtoModel = ProjectRouteStopMovingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
